// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gJKb","controls":"styles_controls__2uTqH","charLimit":"styles_charLimit__29gyV","input":"styles_input__fwMpr","send":"styles_send__3wX_y"};